import NeptuneWidget from './NeptuneWidget.svelte'

const env = process.env.NODE_ENV
const mode = env || 'development'

const target = document.body

const neptuneWidget = (settingsResponse) => new NeptuneWidget({
  target,
  devtool: 'source-map',
  mode,
  props: {
    settingsResponse
  }
})

export default neptuneWidget
